import { useCallback, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { toast } from "sonner";
import { useChatActions } from "./chat/useChatActions";
import { useClapWake } from "./chat/useClapWake";
import { MessageList } from "./chat/MessageList";
import { MessageInput } from "./chat/MessageInput";

export const ConversationPanel = forwardRef(function ConversationPanel({ onStateChange, onListeningChange }, ref) {
  const chat = useChatActions(onStateChange);
  const inputRef = useRef(null);
  const onClap = useCallback(() => { inputRef.current?.focus(); toast.success("You have my attention, Sir."); }, []);
  const { clapOn, toggleClap } = useClapWake(onClap);
  useEffect(() => { onListeningChange?.(clapOn); }, [clapOn, onListeningChange]);
  const { runBriefing, send, setInput } = chat;
  useImperativeHandle(ref, () => ({
    runBriefing, sendText: send,
    focus: () => inputRef.current?.focus(),
    prefill: (text) => { setInput(text); inputRef.current?.focus(); }, toggleClap,
  }), [runBriefing, send, setInput, toggleClap]);

  return <div className="flex flex-col h-full min-h-0">
    <MessageList messages={chat.messages} busy={chat.busy} />
    <MessageInput chat={chat} inputRef={inputRef} clapOn={clapOn} toggleClap={toggleClap} />
  </div>;
});
